import { render } from "./BusGlassPrintBatch.vue?vue&type=template&id=99e836c6&scoped=true"
import script from "./BusGlassPrintBatch.vue?vue&type=script&lang=js"
export * from "./BusGlassPrintBatch.vue?vue&type=script&lang=js"

import "./BusGlassPrintBatch.vue?vue&type=style&index=0&id=99e836c6&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99e836c6"]])

export default __exports__